import React from 'react'
import {AppType} from '@/enum'
import HoseLogoImg from '@/assets/img/logo/logo.png'
import HWHTLogo from '@/assets/img/logo/hwht.jpg'
import ESIGNLogo from '@/assets/img/logo/esign.jpg'
import DINGTALKLogo from '@/assets/img/logo/dingtalk.jpg'
import FEISHULogo from '@/assets/img/logo/feishu.jpg'
import KINGDEELogo from '@/assets/img/logo/kingdee.jpg'
import ZJZLogo from '@/assets/img/logo/zjz.jpg'
import JSTLogo from '@/assets/img/logo/jst.jpg'
import ETEMSLogo from '@/assets/img/logo/eteams.jpg'
import YUNZJLogo from '@/assets/img/logo/yunzj.jpg'
import BEISENLogo from '@/assets/img/logo/beisen.jpg'
import QYSLogo from '@/assets/img/logo/qiyuesuo.jpg'
import NuoNuoLogo  from '@/assets/img/logo/nuonuo.jpg'
import SeeyonLogo from '@/assets/img/logo/seeyon.jpg'
import SeeyonEhrLogo from '@/assets/img/logo/seeyonehr.jpg'
import DidiLogo from '@/assets/img/logo/didi.jpg'
import WangShangLogo from '@/assets/img/logo/wangshang.jpg'
import XRXSLogo from '@/assets/img/logo/xrxs.jpg'
import GBZCLogo from '@/assets/img/logo/gbzc.jpg'
import XSYLogo from '@/assets/img/logo/xsy.jpg'
import FXXKLogo from '@/assets/img/logo/fxxk.jpg'

const OutDiv = (img: string, size: number) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: "1px solid #d6d6d6",
        borderRadius: 6,
        overflow: "hidden",
        paddingInline: "6px",
        background: "#ffffff"
      }}
      className={"flex items-center justify-items-center"}
    >
      <img className={"w-full"} style={{display: 'block'}} src={img} alt={""}/>
    </div>
  )
}

/**
 * logo
 * @constructor
 */
const LogoDom = (type: AppType, size?: number) => {
  switch (type) {
    case AppType.HWHT:
      return OutDiv(HWHTLogo, size || 40)
    case AppType.ESIGN:
      return OutDiv(ESIGNLogo, size || 40)
    case AppType.DINGTALK:
      return OutDiv(DINGTALKLogo, size || 40)
    case AppType.FEISHU:
      return OutDiv(FEISHULogo, size || 40)
    case AppType.KINGDEE:
      return OutDiv(KINGDEELogo, size || 40)
    case AppType.KINGDEE_CLIENT:
    return OutDiv(KINGDEELogo, size || 40)
    case AppType.ZJZ:
      return OutDiv(ZJZLogo, size || 40)
    case AppType.JST:
      return OutDiv(JSTLogo, size || 40)
    case AppType.ETEAMS:
      return OutDiv(ETEMSLogo, size || 40)
    case AppType.YUNZJ:
      return OutDiv(YUNZJLogo, size || 40)
    case AppType.BEISEN:
      return OutDiv(BEISENLogo, size || 40)
    case AppType.QIYUESUO:
      return OutDiv(QYSLogo, size || 40)
    case AppType.SAAS_QIYUESUO:
    return OutDiv(QYSLogo, size || 40)
    case AppType.DIANDANG:
      return OutDiv(HoseLogoImg, size || 40)
    case AppType.NUONUO:
      return OutDiv(NuoNuoLogo, size || 40)
    case AppType.SEEYON:
      return OutDiv(SeeyonLogo, size || 40)
    case AppType.SEEYON_EHR:
      return OutDiv(SeeyonEhrLogo, size || 40)
    case AppType.DIDI:
      return OutDiv(DidiLogo, size || 40)
    case AppType.WANGSHANGBANK:
      return OutDiv(WangShangLogo, size || 40)
    case AppType.XRXS:
      return OutDiv(XRXSLogo, size || 40)
    case AppType.GBZC:
      return OutDiv(GBZCLogo, size || 40)
    case AppType.XSY:
      return OutDiv(XSYLogo, size || 40)
    case AppType.FXXK:
      return OutDiv(FXXKLogo, size || 40)
    case AppType.HOSE:
    default:
      return OutDiv(HoseLogoImg, size || 40)
  }
}

export default LogoDom
